import React from 'react';
import FlexParent from '../../components/shared/flex/FlexParent';
import FlexItem from '../../components/shared/flex/FlexItem';
import styled from 'styled-components';
import Card from '../../components/shared/card/Card';
import { getTime, applyTimezone } from '../../helpers/date';

const Times = styled(FlexItem)`
  text-align: center;
  margin-right: 15px;
  font-size: 1.5rem;
`;

const TimeStart = styled.div`
  color: ${props => props.theme.darkGrey};
  padding-bottom: 4px;
`;

const TimeEnd = styled.div`
  color: ${props => props.theme.shadowGrey};
`;

const CategoryCircle = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: red;
  margin: 5px;
`;

const SessionName = styled.div`
  font-size: 1.5rem;
  padding: 3px 0 3px 0;
`;

const SessionLocation = styled.div`
  padding: 0 10px 0 0;
  font-size: 1.2rem;
  color: ${props => props.theme.shadowGrey};
`;

class AgendaSession extends React.Component {
  nowIsRendered = false;

  render() {
    this.nowIsRendered = false;
    const { matchParams, history, session, timezone } = this.props;
    const { appId, eventId } = matchParams;

    const sessionUrl = `/apps/${appId}/events/${eventId}/agendas/${session.agenda_id}/sessions/${session.id}`;

    return (
      <Card
        margin={`15px 0 15px ${session.parent_id ? '50px' : ''}`}
        padding={'10px'}
        onClick={event => {
          history.push(sessionUrl);
        }}
      >
        <FlexParent alignItems={'center'}>
          <Times shrink={'0'}>
            <TimeStart>{getTime(applyTimezone(session.start_date, timezone))}</TimeStart>
            <TimeEnd>{getTime(applyTimezone(session.end_date, timezone))}</TimeEnd>
          </Times>
          <FlexItem>
            <SessionName>{session.name}</SessionName>
            <FlexParent alignItems={'center'}>
              {session.location ? <SessionLocation>{session.location}</SessionLocation> : null}
              {session.categories.map(category => {
                return (
                  <CategoryCircle key={category.id} style={{ backgroundColor: category.color }} />
                );
              })}
            </FlexParent>
          </FlexItem>
        </FlexParent>
      </Card>
    );
  }
}

export default AgendaSession;
